import { gql } from '@apollo/client';

const GET_HEADAR = gql`
  query Header {
    header {
      headerButtons {
        id
        label
        variant
      }
      navigationLinks {
        id
        title
        url
      }
      headerLogo {
        id
        label
        url
        image {
          url
        }
      }
    }
  }
`;

export default GET_HEADAR;
